export var FIELD_PRESETS;
(function (FIELD_PRESETS) {
    FIELD_PRESETS["PROJECT_CREATION"] = "project-creation";
    FIELD_PRESETS["ADDRESS_SHORT_LIST"] = "address-short-list";
    FIELD_PRESETS["ZD_MAP"] = "zdMap";
})(FIELD_PRESETS || (FIELD_PRESETS = {}));
